import React from 'react';
import type { OnboardingStep } from '../../../shared/types/onboarding';
import { WelcomeStep } from './steps/WelcomeStep';
import { CategoriesStep } from './steps/CategoriesStep';
import { BudgetStep } from './steps/BudgetStep';
import { NotificationsStep } from './steps/NotificationsStep';
import { DashboardStep } from './steps/DashboardStep';

export class OnboardingSteps {
  static getSteps(): OnboardingStep[] {
    return [
      {
        id: 'welcome',
        title: '¡Bienvenido a Invirtiendo!',
        description: 'Tu nueva herramienta para controlar tus finanzas personales',
        icon: '👋',
        content: <WelcomeStep />,
        isCompleted: false
      },
      {
        id: 'categories',
        title: 'Configura tus Categorías',
        description: 'Selecciona las categorías de gastos que más usas',
        icon: '📝',
        content: <CategoriesStep />,
        isCompleted: false
      },
      {
        id: 'budget',
        title: 'Establece tu Presupuesto',
        description: 'Define cuánto quieres gastar cada mes',
        icon: '💰',
        content: <BudgetStep />,
        isCompleted: false,
        isOptional: true
      },
      {
        id: 'notifications',
        title: 'Configura las Notificaciones',
        description: 'Decide cómo quieres recibir alertas sobre tus gastos',
        icon: '🔔',
        content: <NotificationsStep />,
        isCompleted: false,
        isOptional: true
      },
      {
        id: 'dashboard',
        title: 'Personaliza tu Dashboard',
        description: 'Elige cómo quieres ver tu información financiera',
        icon: '📊',
        content: <DashboardStep />,
        isCompleted: false,
        isOptional: true
      }
    ];
  }

  static getStepById(stepId: string): OnboardingStep | undefined {
    return this.getSteps().find(step => step.id === stepId);
  }

  static getStepIndex(stepId: string): number {
    return this.getSteps().findIndex(step => step.id === stepId);
  }

  static getTotalSteps(): number {
    return this.getSteps().length;
  }

  static getRequiredSteps(): OnboardingStep[] {
    return this.getSteps().filter(step => !step.isOptional);
  }

  static getOptionalSteps(): OnboardingStep[] {
    return this.getSteps().filter(step => step.isOptional);
  }
}